<div *ngIf="initialized">
  <div class="card">
    <div>
      <header class="card-header bg-light py-3 px-5">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0">{{section}} Form Details</h5>
          <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </header>
      <div class="card-body">
        <div class="cs_container">
          <div class="cs_popover-body">
            <p class="cs_text-center">
              {{getTextDescription()}}
            </p>


            <!--GENERAL-->
            <div *ngIf="section == 'General'" class="cs_grid cs_mb-md cs_gap-md">
              <div class="cs_details-tile">
                <h5>Cadence</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/cadence-icon.png" alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">{{analysis.cadence.value | number:'1.0-0'}} spm</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.cadence.score | enumString: categoryScoreEnum | lowercase }}">{{overrideScore( analysis.cadence.score | enumString: categoryScoreEnum) }}</div>
                    </div>
                    <div class="cs_details-item"></div>
                  </div>
                </div>
                <h6>Number of steps per minute while running</h6>
              </div>

              <div class="cs_details-tile">
                <h5>Vertical Oscillation</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/vertical-oscillation-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">{{analysis.verticalOscillation.value  | number:'1.0-0'}} cm</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.verticalOscillation.score | enumString: categoryScoreEnum | lowercase }}">{{ overrideScore(analysis.verticalOscillation.score | enumString: categoryScoreEnum )}}</div>
                    </div>
                    <div class="cs_details-item"></div>
                  </div>
                </div>
                <h6>Amount of up-and-down movement while running</h6>
              </div>

              <div class="cs_details-tile">
                <h5>Ground Contact Time</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/ground-contact-time-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">R {{analysis.groundContactTime.rightValue| number:'1.0-0'}} ms</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.groundContactTime.rightScore | enumString: categoryScoreEnum | lowercase }}">{{ overrideScore(analysis.groundContactTime.rightScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                    <div class="cs_details-item">L {{analysis.groundContactTime.leftValue| number:'1.0-0'}} ms</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.groundContactTime.leftScore | enumString: categoryScoreEnum | lowercase }}">{{ overrideScore(analysis.groundContactTime.leftScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                  </div>
                </div>
                <h6>Time your foot stays on the ground with each step</h6>
              </div>

              <div class="cs_details-tile">
                <h5>Stride Length</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/stride-length-icon.png" alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">R {{analysis.strideLength.rightValue| number:'1.0-0'}} cm</div>
                    <div class="cs_details-item">
                      <!-- placeholder -->
                    </div>
                    <div class="cs_details-item">L {{analysis.strideLength.rightValue| number:'1.0-0'}} cm</div>
                    <div class="cs_details-item">
                      <!-- placeholder -->
                    </div>
                  </div>
                </div>
                <h6>Distance covered with each step while running</h6>
              </div>
            </div>


            <!--PELVIS-->
            <div *ngIf="section == 'Pelvis'" class="cs_grid cs_mb-md cs_gap-md">
              <div class="cs_details-tile">
                <h5>Peak Contralateral Pelvic Drop</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/cpd-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">R {{removeNegtiveSign(analysis.peakCPD.rightValue) | number:'1.0-0'}}° {{getLabelPelvicDrop(analysis.peakCPD.rightValue, false)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.peakCPD.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakCPD.rightScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                    <div class="cs_details-item">L {{removeNegtiveSign(analysis.peakCPD.leftValue)| number:'1.0-0'}}° {{getLabelPelvicDrop(analysis.peakCPD.leftValue, true)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.peakCPD.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakCPD.leftScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                  </div>
                </div>
                <h6>Amount the opposite hip drops while on the ground</h6>
              </div>

              <div class="cs_details-tile">
                <h5>Forward Lean</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/forward-lean-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">{{removeNegtiveSign(analysis.forwardLean.value)| number:'1.0-0'}}° {{getLabelForwardLean(analysis.forwardLean.value)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.forwardLean.score | enumString: categoryScoreEnum | lowercase }}">{{ overrideScore(analysis.forwardLean.score | enumString: categoryScoreEnum )}}</div>
                    </div>
                  </div>
                </div>
                <h6>Angle of your body's lean while running</h6>
              </div>
            </div>


            <!--HIPS-->
            <div *ngIf="section == 'Hips'" class="cs_grid cs_mb-md cs_gap-md">
              <div class="cs_details-tile">
                <h5>Peak Hip Adduction</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/peak-hip-adduction-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">R {{removeNegtiveSign(analysis.peakHipAdduction.rightValue)| number:'1.0-0'}}° {{getLabelHipAdduction(analysis.peakHipAdduction.rightValue)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.peakHipAdduction.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakHipAdduction.rightScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                    <div class="cs_details-item">L {{removeNegtiveSign(analysis.peakHipAdduction.leftValue)| number:'1.0-0'}}° {{getLabelHipAdduction(analysis.peakHipAdduction.leftValue)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.peakHipAdduction.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakHipAdduction.leftScore | enumString: categoryScoreEnum) }}</div>
                    </div>
                  </div>
                </div>
                <h6>Inward movement of the thigh toward the midline</h6>
              </div>

              <div class="cs_details-tile">
                <h5>Peak Hip Flexion</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/peak-hip-flexion-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">R {{removeNegtiveSign(analysis.peakHipFlexion.rightValue)| number:'1.0-0'}}° flex</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.peakHipFlexion.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakHipFlexion.rightScore | enumString: categoryScoreEnum)}}</div>
                    </div>
                    <div class="cs_details-item">L {{removeNegtiveSign(analysis.peakHipFlexion.leftValue)| number:'1.0-0'}}° flex</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.peakHipFlexion.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakHipFlexion.leftScore | enumString: categoryScoreEnum)}}</div>
                    </div>
                  </div>
                </div>
                <h6>Maximum forward angle of the hip while running</h6>
              </div>

              <div class="cs_details-tile">
                <h5>Peak Hip Extension</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/peak-hip-extension-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">R {{removeNegtiveSign(analysis.peakHipExtension.rightValue)| number:'1.0-0'}}° ext</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.peakHipExtension.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakHipExtension.rightScore | enumString: categoryScoreEnum)}}</div>
                    </div>
                    <div class="cs_details-item">L {{removeNegtiveSign(analysis.peakHipExtension.leftValue)| number:'1.0-0'}}° ext</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.peakHipExtension.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakHipExtension.leftScore | enumString: categoryScoreEnum)}}</div>
                    </div>
                  </div>
                </div>
                <h6>Maximum backward angle of the hip while running</h6>
              </div>
            </div>


            <!--KNEES-->
            <div *ngIf="section == 'Knees'" class="cs_grid cs_mb-md cs_gap-md">
              <div class="cs_details-tile">
                <h5>Peak Knee Flexion</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/peak-knee-flexion-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">R {{removeNegtiveSign(analysis.peakKneeFlexion.rightValue)| number:'1.0-0'}}° flex</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.peakKneeFlexion.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakKneeFlexion.rightScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                    <div class="cs_details-item">L {{removeNegtiveSign(analysis.peakKneeFlexion.leftValue)| number:'1.0-0'}}° flex</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.peakKneeFlexion.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakKneeFlexion.leftScore | enumString: categoryScoreEnum) }}</div>
                    </div>
                  </div>
                </div>
                <h6>Maximum bend of the knee while on the ground</h6>
              </div>

              <div class="cs_details-tile">
                <h5>Strike from Center of Mass</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/strike-from-com-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">R {{removeNegtiveSign(analysis.scom.rightValue)| number:'1.0-0'}} cm</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.scom.rightScore | enumString: categoryScoreEnum | lowercase }}">{{ overrideScore(analysis.scom.rightScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                    <div class="cs_details-item">L {{removeNegtiveSign(analysis.scom.leftValue)| number:'1.0-0'}} cm</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.scom.leftScore | enumString: categoryScoreEnum | lowercase }}">{{ overrideScore(analysis.scom.leftScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                  </div>
                </div>
                <h6>Distance between foot strike and your body's center of mass</h6>
              </div>

              <div class="cs_details-tile">
                <h5>Tibial Inclination</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/yibial-inclination-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">R {{removeNegtiveSign(analysis.icTibialInclination.rightValue)| number:'1.0-0'}}° {{getLabelTibialInclination(analysis.icTibialInclination.rightValue)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.icTibialInclination.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore( analysis.icTibialInclination.rightScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                    <div class="cs_details-item">L {{removeNegtiveSign(analysis.icTibialInclination.leftValue)| number:'1.0-0'}}° {{getLabelTibialInclination(analysis.icTibialInclination.leftValue)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.icTibialInclination.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore( analysis.icTibialInclination.leftScore | enumString: categoryScoreEnum) }}</div>
                    </div>
                  </div>
                </div>
                <h6>Angle of your shin at the moment of foot strike</h6>
              </div>

              <div class="cs_details-tile">
                <h5>Stiffness</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/stiffness-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content longer-label">
                    <div class="cs_details-item">R {{removeNegtiveSign(analysis.stiffness.rightValue / 1000)| number:'1.1-1'}} kN/m</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.stiffness.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore( analysis.stiffness.rightScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                    <div class="cs_details-item">L {{removeNegtiveSign(analysis.stiffness.leftValue / 1000)| number:'1.1-1'}} kN/m</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.stiffness.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore( analysis.stiffness.leftScore | enumString: categoryScoreEnum) }}</div>
                    </div>
                  </div>
                </div>
                <h6>Measure of your legs ability to absorb impact and return it for propulsion</h6>
              </div>
            </div>

            <!--Ankle-->
            <div *ngIf="section == 'Ankles'" class="cs_grid cs_mb-md cs_gap-md">
              <div class="cs_details-tile">
                <h5>Peak Ankle Pronation</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/peak-ankle-pronation-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">R {{removeNegtiveSign(analysis.peakAnklePronation.rightValue)| number:'1.0-0'}}° {{getLabelAnklePronatoin(analysis.peakAnklePronation.rightValue)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.peakAnklePronation.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakAnklePronation.rightScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                    <div class="cs_details-item">L {{removeNegtiveSign(analysis.peakAnklePronation.leftValue)| number:'1.0-0'}}° {{getLabelAnklePronatoin(analysis.peakAnklePronation.leftValue)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.peakAnklePronation.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakAnklePronation.leftScore | enumString: categoryScoreEnum) }}</div>
                    </div>
                  </div>
                </div>
                <h6>Inward roll of the foot after landing</h6>
              </div>

              <div class="cs_details-tile">
                <h5>Foot Inclination</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/foot-inclination-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">R {{removeNegtiveSign(analysis.icFootInclination.rightValue)| number:'1.0-0'}}° {{getLabelFootInclination(analysis.icFootInclination.rightValue)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.icFootInclination.rightScore | enumString: categoryScoreEnum | lowercase }}">{{ overrideScore(analysis.icFootInclination.rightScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                    <div class="cs_details-item">L {{removeNegtiveSign(analysis.icFootInclination.leftValue)| number:'1.0-0'}}° {{getLabelFootInclination(analysis.icFootInclination.leftValue)}}</div>
                    <div class="cs_details-item">
                      <div class="cs_score s-{{ analysis.icFootInclination.leftScore | enumString: categoryScoreEnum | lowercase }}">{{ overrideScore(analysis.icFootInclination.leftScore | enumString: categoryScoreEnum )}}</div>
                    </div>
                  </div>
                </div>
                <h6>Angle of the foot at the moment of foot strike</h6>
              </div>

              <div class="cs_details-tile">
                <h5>Foot Strike</h5>
                <div class="cs_details-wrapper">
                  <div class="cs_details-img">
                    <img src="../../../../assets/img/assessment/foot-strike-icon.png"
                         alt="" />
                  </div>
                  <div class="cs_details-content">
                    <div class="cs_details-item">R: {{analysis.footStrikeRight| enumString: footStrikePatternEnum}}</div>
                    <div class="cs_details-item">
                      <!-- placeholder -->
                    </div>
                    <div class="cs_details-item">L: {{analysis.footStrikeLeft| enumString: footStrikePatternEnum}}</div>
                    <div class="cs_details-item">
                      <!-- placeholder -->
                    </div>
                  </div>
                </div>
                <h6>Position of foot at the moment of foot strike</h6>
              </div>
            </div>

            <div class="cs_score_description cs_mb-0">
              <div class="cs_score_container">
                <div class="cs_score s-g">e</div>
                Excellent
              </div>

              <div class="cs_score_container">
                <div class="cs_score s-gf">g</div>
                Good
              </div>

              <div class="cs_score_container">
                <div class="cs_score s-f">f</div>
                Fair
              </div>
              <div class="cs_score_container">
                <div class="cs_score s-p">p</div>
                Poor
              </div>
            </div>
          </div>
        </div>
      </div>
     </div>
  </div>
</div>
